import MobileHeader from './MobileHeader';

export default MobileHeader;
